import { render, staticRenderFns } from "./AccessLists.vue?vue&type=template&id=38ea0539"
import script from "./AccessLists.vue?vue&type=script&lang=js"
export * from "./AccessLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports